import { StripeError } from '@stripe/stripe-js'
import React from 'react'

import { stripeErrors } from '@/components/payment/stripe/stripe-errors'
import { AlertBanner } from '@/components/shared/alert-banner'
import { cn } from '@/lib/utils'

type Props = {
  error: StripeError
  className?: string
}

export const StripeErrorAlert = ({ error, className }: Props) => {
  if (!error) return null

  const errorBody = stripeErrors[error.type] || {
    title: 'Error',
    message: (error) => error.message,
  }

  return (
    <AlertBanner variant="destructive" className={cn(className)}>
      {errorBody.message({ message: error.message || '' })}
    </AlertBanner>
  )
}
